// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/blocks/details.scss
// module id = 55
// module chunks = 62